import React from 'react';
import cn from 'classnames';
import Tooltip from '@dealroadshow/uikit-tooltip';
import { dataTableStyles } from '@dealroadshow/uikit-table/DataTable';
import IconQuestion from '@dealroadshow/uikit-icon/IconQuestion';
import { CheckboxInput } from '@dealroadshow/uikit-checkbox';

import CountryIdField from './cells/CountryIdField';
import CountryForCell from './cells/CountryForCell';
import DeleteCell from './cells/DeleteCell';
import { Field } from '@framework/ui/Organisms/FinalForm';

import { CallFormInstance } from '../interfaces';
import { IDialInCountryTableRowItem } from './interfaces';

import styles from './dialInCountriesTable.module.scss';
import alignStyles from '@dealroadshow/uikit-styles/helpers/align.module.scss';

const DIAL_IN_FOR_COLUMN_EXPLAINER = 'Select Display to choose which Countries you want to highlight for your Speakers and Participants. All other country dial-ins will be displayed in a tooltip. Note that this only applies to Embedded Dial-Ins and Pre-Registration as other call types display all dial-ins by default.';
const DISPLAY_COLUMN_EXPLAINER = 'Select Display to choose which Countries you want to highlight for your Speakers and Participants. Please list priority countries first. All other country dial-ins will be displayed in a tooltip. Note that this only applies to Embedded Dial-Ins and Pre-Registration as other call types display all dial-ins by default.';

const DIAL_IN_COUNTRIES_DEFAULT_COLUMNS = [
  {
    name: 'countryIdCell',
    title: 'Country',
    className: cn(styles.countryIdCell, dataTableStyles.inputCol),
    width: 265,
    maxWidth: 265,
    cellCallback: CountryIdField,
  },
  {
    name: 'dashCell',
    title: '',
    className: styles.dashRowCell,
    cellCallback: () => '-',
  },
  {
    name: 'countryForCell',
    className: dataTableStyles.inputCol,
    width: 255,
    maxWidth: 255,
    headCallback: () => (
      <>
        Dial-In For
        <Tooltip
          containerClassName={ styles.questionIconContainer }
          content={ (
            <div className={ styles.dialInCountriesTableExplainersContainer }>
              { DIAL_IN_FOR_COLUMN_EXPLAINER }
            </div>
          ) }
        >
          <IconQuestion className={ styles.questionIcon } />
        </Tooltip>
      </>
    ),
    cellCallback: CountryForCell,
  },
  {
    name: 'deleteCell',
    title: '',
    className: dataTableStyles.actionCol,
    cellCallback: DeleteCell,
  },
];

export const DIAL_IN_COUNTRIES_TABLE_COLUMNS_BY_INSTANCE = {
  [CallFormInstance.ScheduleYourCall]: DIAL_IN_COUNTRIES_DEFAULT_COLUMNS,
  [CallFormInstance.CallSettingsForm]: [
    ...DIAL_IN_COUNTRIES_DEFAULT_COLUMNS.slice(0, 3),
    {
      name: 'countryDisplayCell',
      width: 90,
      maxWidth: 90,
      className: alignStyles.alignCenter,
      headCallback: () => (
        <>
          Display
          <Tooltip
            containerClassName={ styles.questionIconContainer }
            content={ (
              <div className={ styles.dialInCountriesTableExplainersContainer }>
                { DISPLAY_COLUMN_EXPLAINER }
              </div>
            ) }
          >
            <IconQuestion className={ styles.questionIcon } />
          </Tooltip>
        </>
      ),
      cellCallback: ({ row }: { row: IDialInCountryTableRowItem }) => (
        <Field
          component={ CheckboxInput }
          type="checkbox"
          name={ `${ row.fieldName }.countryDisplay` }
          dataTest="countryDisplay"
        />
      ),
    },
    {
      name: 'dragAndDropCell',
      className: cn(styles.dragCell, dataTableStyles.draggableCol, alignStyles.alignCenter),
      isDraggable: true,
      title: '',
      width: 40,
      maxWidth: 40,
    },
    DIAL_IN_COUNTRIES_DEFAULT_COLUMNS[3],
  ],
};
